export const DefaultLocalizationLabel = [

    { "RMMaster": "Manage Raw Material" },
    { "RMCategoryLabel": "Category" },
    { "BOPCategoryLabel": "BOP Category" },
    { "TechnologyLabel": "Technology" },
    { "VendorLabel": "Vendor" },
    { "RMVendorLabel": "Vendor" },
    { "BOPVendorLabel": "Vendor" },
]